
/* ============================== src/components/discussion/CommentReactions.jsx ============================== */
// src/components/discussion/CommentReactions.jsx
import { Emoji } from "emoji-picker-react";
import { useDiscussion } from "./context";
import { unifiedOf } from "../../utils/reactions";
import { EMOJI_STYLE, EMOJI_SIZE_CHIP, getEmojiUrl } from "./emojiStyle";

/**
 * Ряд уже поставленных реакций под комментарием.
 *
 * Порядок и состав - по ключам comment.reactions. Реакции, которых
 * больше нет в REACTIONS (например, старые ✅ из mock-данных),
 * отображаются fallback-спаном: для таких unifiedOf вернёт null.
 *
 * Стиль, размер и URL спрайтов - из общего emojiStyle.js. Размер
 * чипа меньше, чем в пикере: чип встроен в строку рядом со
 * счётчиком, крупный эмодзи там смотрелся бы несоразмерно.
 *
 * getEmojiUrl подменяет внешний CDN на локальную раздачу PNG из
 * public/emoji/apple/.
 */
export default function CommentReactions({ comment }) {
  const { currentUser, getAuthor, setReaction } = useDiscussion();

  const reactions = comment.reactions || {};
  const entries = Object.entries(reactions).filter(
    ([, users]) => users?.length > 0,
  );

  if (entries.length === 0) return null;

  return (
    <div className="cm-reactions">
      {entries.map(([emoji, users]) => {
        const mine = users.includes(currentUser.id);
        const title = users
          .map((id) => {
            const e = getAuthor(id);
            return e ? `${e.last} ${e.first}` : id;
          })
          .join(", ");

        const unified = unifiedOf(emoji);

        return (
          <button
            key={emoji}
            type="button"
            className={`reaction-chip${mine ? " on" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              setReaction(comment.id, emoji);
            }}
            title={title}
          >
            {unified ? (
              <Emoji
                unified={unified}
                size={EMOJI_SIZE_CHIP}
                emojiStyle={EMOJI_STYLE}
                getEmojiUrl={getEmojiUrl}
                lazyLoad
              />
            ) : (
              <span className="reaction-emoji">{emoji}</span>
            )}
            <span className="reaction-count">{users.length}</span>
          </button>
        );
      })}
    </div>
  );
}
